import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

const itemKey = (i) => (i.variant ? `${i.slug}__${i.variant}` : i.slug);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("gf_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("gf_cart", JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const key = itemKey(item);
      const existing = prev.find((i) => itemKey(i) === key);
      if (existing) {
        return prev.map((i) => (itemKey(i) === key ? { ...i, qty: i.qty + 1 } : i));
      }
      return [...prev, { ...item, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => itemKey(i) !== key));

  const setQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => itemKey(i) !== key)
        : prev.map((i) => (itemKey(i) === key ? { ...i, qty } : i))
    );

  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.qty, 0);
  const total = items.reduce((a, i) => a + i.price_dkk * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, open, setOpen, add, remove, setQty, clear, count, total }}
    >
      {children}
    </CartContext.Provider>
  );
}
